import React, { useState, useRef, useEffect } from "react";

import api from "./api/api";
import { toast } from "react-toastify";
import { TextField, Autocomplete } from "@mui/material";
import socketIO from "socket.io-client";
import { FaPaperPlane } from "react-icons/fa";
const socketUrl = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_SOCKET_URL_LOCAL || window.location.origin;
const socket = socketIO.connect(socketUrl, {
  transports: ["websocket"],
});
//prova
const mansioni = [
  { label: "Advertiser" },
  { label: "Brand Strategist" },
  { label: "Content Creator" },
  { label: "Creative Director" },
  { label: "Content Marketer" },
  { label: "Creative Strategist" },
  { label: "Data Analyst" },
  { label: "Digital Strategist" },
  { label: "Email Marketing Expert" },
  { label: "Marketing Strategist" },
  { label: "PPC specialist" },
  { label: "Prompt Engineer" },
  { label: "Psicologo Comportamentale" },
  { label: "Seo Manager" },
  { label: "Social Media Manager" },
  { label: "UX Design Expert" },
];

const Collega = () => {
  const [file, setFile] = useState(null);
  const [sended, setSended] = useState(false);
  const [answer, setAnwser] = useState("");
  const chatContainer = useRef();

  const storedJob = typeof window !== "undefined" ? localStorage.getItem("selectedJobLabel") : null;
  const initialSelected = storedJob ? mansioni.find((m) => m.label === storedJob) || null : null;
  const [job, setJob] = useState(storedJob || "");
  const [selectedJob, setSelectedJob] = useState(initialSelected);

  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Ciao, sono il tuo collega virtuale. Se non hai già scelto una mansione, fallo dal menù a tendina in alto, sarò lieto di aiutarti in qualsiasi tuo problema",
      sender: "bot",
    },
  ]);

  const [domanda, setDomanda] = useState("");

  const askToAi = (e) => {
    e.preventDefault();
    if (job === "") {
      setSended(true);
    } else {
      setSended(false);
      let obj = {};
      obj.job = job;
      obj.domanda = domanda;
      obj.username = sessionStorage.getItem("username") || "";

      socket.emit("mex", obj);

      if (domanda.trim() !== "") {
        setDomanda("");
      }
      setMessages((prev) => [
        ...prev,
        { id: Date.now(), sender: "user", text: domanda },
      ]);
    }
  };

  useEffect(() => {
    const handleResponse = (arg) => {
      if (arg?.response && arg.response.toLowerCase().includes("token esauriti")) {
        toast.error(arg.response);
      }
      setMessages((prev) => [
        ...prev,
        { id: Date.now(), sender: "bot", text: arg.response },
      ]);
      window.dispatchEvent(new Event("tokens-updated"));
    };

    socket.on("response", handleResponse);
    return () => socket.off("response", handleResponse);
  }, []);

  const handleInputChange = (event) => {
    setDomanda(event.target.value);
  };

  const askToFile = async () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("question", domanda);

    let res = await api.post("readDocument", formData, {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    setAnwser(res.data.results);
  };

  const handleJobChange = async (selection) => {
    if (selection) {
      setJob(selection.label);
      setSelectedJob(selection);
      localStorage.setItem("selectedJobLabel", selection.label);
      socket.emit("setJob", selection.label);
    } else {
      setJob("");
      setSelectedJob(null);
      localStorage.removeItem("selectedJobLabel");
    }
  };

  return (
    <>
      <div className="surface-card mt-4 p-4 sm:p-7 text-[var(--brand-dark)]">
        <div className="w-full md:w-72 relative z-20">
          <Autocomplete
            id="mansione-selector"
            options={mansioni}
            value={selectedJob}
            fullWidth
            onChange={(event, selection) => handleJobChange(selection)}
            isOptionEqualToValue={(option, value) => option.label === value.label}
            slotProps={{ popper: { sx: { zIndex: 1500 } } }}
            popupIcon={null}
            sx={{ backgroundColor: "transparent" }}
            PaperComponent={(props) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  zIndex: 50,
                  backgroundColor: "#ffffff",
                  color: "var(--brand-dark)",
                  borderRadius: 16,
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "1px solid rgba(38,42,115,0.08)",
                }}
              />
            )}
            renderOption={(props, option) => (
              <li
                {...props}
                className="px-3 py-2 text-sm"
                style={{ color: "var(--brand-dark)" }}
              >
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                hiddenLabel
                variant="filled"
                placeholder="Seleziona la mansione"
                InputLabelProps={{ shrink: false }}
                sx={{
                  "& .MuiFilledInput-root": {
                    backgroundColor: "#ffffff",
                    borderRadius: 999,
                    minHeight: 52,
                    alignItems: "center",
                    padding: "0 6px",
                    boxShadow: "0 6px 14px rgba(0,0,0,0.05)",
                    "&:hover": { backgroundColor: "#ffffff" },
                    "&.Mui-focused": { backgroundColor: "#ffffff", boxShadow: "0 0 0 2px rgba(38,42,115,0.12)" },
                  },
                  "& .MuiFilledInput-input": {
                    color: "var(--brand-dark)",
                    fontWeight: 600,
                    padding: "0 18px",
                    lineHeight: 1.4,
                    textAlign: "center",
                    "::placeholder": { color: "rgba(39,55,62,0.9)" },
                  },
                  "& .MuiSvgIcon-root": { color: "rgba(39,55,62,0.7)" },
                }}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            )}
          />
        </div>
        <div className="flex flex-row gap-4 mt-4">
          <div className="flex flex-col flex-auto h-[60vh]">
            <div className="flex flex-col h-full overflow-x-auto mb-4">
              <div className="flex flex-col h-full">
                <div className="grid grid-cols-12 gap-y-2" ref={chatContainer}>
                  {messages.map((el) => {
                    return el.sender === "bot" ? (
                      <div key={el.id} className="col-start-1 col-end-12 md:col-end-8 rounded-lg">
                        <div className="flex flex-row items-end">
                          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-dark-blue text-white font-semibold text-lg flex-shrink-0 ">
                            P
                          </div>
                          <div className="relative ml-3 text-base bg-white border border-[rgba(39,55,62,0.15)] text-[var(--brand-dark)] font-normal py-2 px-4 shadow rounded-xl">
                            {el.text}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div key={el.id} className=" col-start-1 md:col-start-6 col-end-13 rounded-lg">
                        <div className="flex items-end justify-start flex-row-reverse">
                          <div className="flex items-center justify-center h-10 w-10 rounded-full bg-dark-blue text-white font-semibold text-lg flex-shrink-0 ">
                            U
                          </div>
                          <div className="relative mr-3 text-base bg-white border border-[rgba(39,55,62,0.15)] text-[var(--brand-dark)] font-normal py-2 px-4 shadow rounded-xl">
                            {el.text}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <form
              className="flex flex-row items-end w-full gap-4"
              onSubmit={askToAi}
            >
              <div className="flex flex-wrap w-full">
                {sended ? (
                  <div className="text-[var(--brand-dark)] text-xs md:text-sm font-semibold mb-1 ">
                    Scegli una Mansione prima di inviare
                  </div>
                ) : (
                  <></>
                )}
                <input
                  type="text"
                  className="input-text input-text-dark"
                  placeholder="Inserisci una domanda"
                  value={domanda}
                  onChange={handleInputChange}
                />
              </div>
              <button
                onClick={askToAi}
                type="submit"
                className="button-prophet"
              >
                <FaPaperPlane color="white"/>
                Invia
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Collega;
